import { httpClient, resolveApiUrl } from '#shared/api'
import { getTgBotRole } from '#shared/lib/auth'
import CreateUserPayload from '../model/create-user-payload'
import CreateUserResponse from '../model/create-user-response'

export default async function createUser(createUserPayload: CreateUserPayload) {
  const botRole = getTgBotRole()
  const response = await httpClient.post<CreateUserResponse>(`${botRole}/users`, {
    json: createUserPayload,
    prefixUrl: resolveApiUrl('@sd-tg-bot'),
    headers: {
      'telegram-init-data': Telegram.WebApp.initData,
    },
    skipAuth: true,
  })

  const responseBody = await response.json()

  return responseBody
}
